import { render, staticRenderFns } from "./preview-form-button.vue?vue&type=template&id=906db72a&scoped=true"
import script from "./preview-form-button.vue?vue&type=script&lang=js"
export * from "./preview-form-button.vue?vue&type=script&lang=js"
import style0 from "./preview-form-button.vue?vue&type=style&index=0&id=906db72a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906db72a",
  null
  
)

export default component.exports